import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';

import { getDedobCss, getDedobUser, getDocument } from '../restapi/document';
import { EditionState } from '../restapi/types';


// read current user
export function useDedobUser() {
	const userQuery = useQuery(['user'], () => getDedobUser(), {
		staleTime: Infinity,  // never reload
		cacheTime: Infinity,  // never reload
	});
	return userQuery.data;
}

// read dob document css file from server
export function useDedobCss() {
	const userQuery = useQuery(['css'], () => getDedobCss(), {
		staleTime: Infinity,  // never reload
		cacheTime: Infinity,  // never reload
	});
	return userQuery.data;
}

// read the docId from url like /2021-05-12   (when empty use today)
export function useDocId() {
	const {date} = useParams<{ date: string }>();
	let id = date || '';
	if (id.length !== 10) {  // must be yyyy-mm-dd
		// WARN there may be some time zone problem around midnight GMT
		id = (new Date()).toISOString().substring(0, 10);  // today
	}
	return id;
}


const dobRefetchInterval = parseInt(import.meta.env.VITE_DOB_REFETCH_INTERVAL_SEC || '20') * 1000;

export function useCurrentDoc() {
	const docId = useDocId();
	const docQuery = useQuery(['doc', docId], () => getDocument(docId), {
		refetchInterval: dobRefetchInterval,  // reload every few seconds
	});
	return docQuery.data;
}

export function useCurrentEdition() {
	const docData = useCurrentDoc();
	return docData?.editionSet?.find(e => e.state === EditionState.current);
}